<template>
<div>
    <!-- Modal -->
    <div class="modal fade" :id="'editarDatosDistribuidora'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Editar Datos Distribuidora</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <b-form>
                        <b-form-group id="input-group-7" label="Distribuidora   :" label-for="input-7">
                            <b-form-select id="input-7" v-model="distribuidora" :options="distribuidoravalores" required show: tru></b-form-select>
                        </b-form-group>
                        <b-container class="bv-example-row">
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-8" label="Potencia    :   " label-for="input-8">
                                        <b-form-input id="input-8" v-model="potencia" type="text" required placeholder="Potencia..."> </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-9" label="Tarifa    :   " label-for="input-9">
                                        <!--<b-form-select id="input-9" v-model="tarifa" :options="tarifavalores" required show: true readonly></b-form-select>-->
                                        {{tarifa}}
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-10" label="Número Cliente    :   " label-for="input-10">
                                        <b-form-input id="input-10" v-model="numerocliente" type="text" required placeholder="Número Cliente"> </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>

                        <b-container class="bv-example-row">
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-11" label="Ultimo Costo CLP/KWh    :   " label-for="input-11">
                                        <b-form-input id="input-11" v-model="costoCLP_KWh" type="number" required placeholder="costoCLP/KWh"> </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-12" label="Ultimo Costo CLP/Transporte:    :   " label-for="input-12">
                                        <b-form-input id="input-12" v-model="costoCLP_transporte" type="number" required placeholder="Costo CLP/Transporte:"> </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-13" label="Precio CLP/Excedente     :   " label-for="input-13">
                                        <b-form-input id="input-13" v-model="precioCLP_excedente" type="number" required placeholder="Precio CLP/Excedente "> </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal" data-placement="top" title="Cerrar"><i class="far fa-times-circle"></i></button>
                    <button type="button" class="btn btn-info" data-dismiss="modal" data-placement="top" title="Guardar" @click.prevent="editarDatosDistribuidora"><i class="far fa-save"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'ModalEditarDatosDistribuidora',
    props: [
        'index'
    ],
    data() {
        return {
            distribuidora: null,
            distribuidoravalores: [],
            potencia: '',
            tarifa: '',
            tarifavalores: [],
            numerocliente: '',
            costoCLP_KWh: 0,
            costoCLP_transporte: 0,
            precioCLP_excedente: 0,
            idDoc: ''
        }
    },
    mounted() {
        this.distribuidora = this.$store.getters.enviarDataClientes[this.index].distribuidora;
        this.potencia = this.$store.getters.enviarDataClientes[this.index].potencia;
        this.numerocliente = this.$store.getters.enviarDataClientes[this.index].numerocliente;
        this.tarifa = this.$store.getters.enviarDataClientes[this.index].tarifa;
        this.costoCLP_KWh = this.$store.getters.enviarDataClientes[this.index].costoCLP_KWh; //costo Kw
        this.costoCLP_transporte = this.$store.getters.enviarDataClientes[this.index].costoCLP_transporte; //costo transporte
        this.precioCLP_excedente = this.$store.getters.enviarDataClientes[this.index].precioCLP_excedente; //precio excedente
        this.idDoc = this.$store.getters.enviarDataClientes[this.index].idDoc;

        this.distribuidoravalores = this.$store.getters.enviarDataDistribuidora;
        this.tarifavalores = this.$store.getters.enviarDataTarifa;
    },
    methods: {
        editarDatosDistribuidora() {
            let auxiliarDistribuidora = {
                idDoc: this.idDoc,
                distribuidora: this.distribuidora,
                potencia: this.potencia,
                tarifa: this.tarifa,
                numerocliente: this.numerocliente,
                costoCLP_KWh: parseFloat(this.costoCLP_KWh),
                costoCLP_transporte: parseFloat(this.costoCLP_transporte),
                precioCLP_excedente: parseFloat(this.precioCLP_excedente),
            }
            this.$store.dispatch('editarDatosDistribuidora', auxiliarDistribuidora)

        }
    }
}
</script>

<style>

</style>
